module.exports = __webpack_public_path__ + "img/blue.1b771d58.png";